import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export const arrowSize = 12;
export const maxAnchorTop = 180;
export const popupMinWidth = 238;
export const popupMinHeight = 112;

export default makeStyles((theme: MuiTheme) => ({
  arrow: {
    position: "absolute",
    width: 0,
    height: 0,
    borderStyle: "solid"
  },
  arrowTop: {
    top: -arrowSize,
    bottom: "auto",
    borderWidth: "0 18px 14px 18px",
    borderColor: "transparent transparent #ffffff transparent"
  },
  arrowBottom: {
    top: "auto",
    bottom: -arrowSize,
    borderWidth: "14px 18px 0 18px",
    borderColor: "#ffffff transparent transparent transparent"
  },
  arrowLeft: {
    left: -arrowSize,
    right: "auto",
    borderWidth: "18px 14px 18px 0",
    borderColor: "transparent #ffffff transparent transparent"
  },
  arrowRight: {
    left: "auto",
    right: -arrowSize,
    borderWidth: "18px 0 18px 14px",
    borderColor: "transparent transparent transparent #ffffff"
  },
  showArrow: {
    display: "block"
  },
  popover: {
    "& .MuiPaper-root": {
      overflow: "visible",
      minWidth: popupMinWidth,
      minHeight: popupMinHeight
    }
  },
  popoverBottom: {
    "& .MuiPopover-paper": {
      marginTop: 16
    }
  },
  popoverTop: {
    "& .MuiPopover-paper": {
      marginTop: -16
    }
  },
  popoverLeft: {
    "& .MuiPopover-paper": {
      marginLeft: -16
    }
  },
  popoverRight: {
    "& .MuiPopover-paper": {
      marginLeft: 16
    }
  },
  popoverContent: {
    position: "relative",
    display: "flex",
    overflow: "hidden",
    minWidth: popupMinWidth,
    minHeight: popupMinHeight
  }
}));
